export default __webpack_public_path__ + "static/media/icon-traveler.6082afd8.svg";